import { useEffect, useRef } from 'react';
import { useUIStore } from '../stores/uiStore';

export function useShareTarget() {
  const { openTaskModal, setSharedFiles } = useUIStore();
  const processedRef = useRef(false);

  useEffect(() => {
    if (typeof window === 'undefined' || processedRef.current) return;

    const params = new URLSearchParams(window.location.search);
    const shareId = params.get('shareId');
    if (!shareId) return;

    processedRef.current = true;

    // Try to load shared files cached by the service worker
    fetch(`/share-target-files?shareId=${encodeURIComponent(shareId)}`)
      .then((res) => (res.ok ? res.json() : null))
      .then((record) => {
        if (!record?.files || record.files.length === 0) {
          openTaskModal();
          return;
        }

        const files = record.files.map(
          (file: { name: string; type: string; lastModified: number; arrayBuffer: number[] }) =>
            new File([new Uint8Array(file.arrayBuffer)], file.name, {
              type: file.type,
              lastModified: file.lastModified,
            })
        );

        setSharedFiles(files);
        openTaskModal();
      })
      .catch((err) => {
        console.error('Failed to load shared files:', err);
        openTaskModal();
      });
  }, [openTaskModal, setSharedFiles]);
}
